import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

class ProductsSeparatePresetsProvider extends HttpRequest {
  getItems () {
    this.setHeader(getAuthToken())
    return this.get('/products-separate-presets')
  }

  createItem (payload) {
    this.setHeader(getAuthToken())
    return this.post('/products-separate-presets', payload)
  }

  updateItem (payload) {
    this.setHeader(getAuthToken())
    return this.put(`/products-separate-presets/${payload.id}`, payload)
  }

  deleteItem (id) {
    this.setHeader(getAuthToken())
    return this.delete(`/products-separate-presets/${id}`)
  }
}

export default ProductsSeparatePresetsProvider
